// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IHc9jwmkyD3tt6WoumDg{display:flex;flex-direction:column;gap:1px}.jjpNcsv5KPzmuNYx4VjG{display:flex;flex-direction:column;gap:1px}`, "",{"version":3,"sources":["webpack://./src/components/navigation/navigation-panel/sub-navigation-panel/contents/navigation-sub-menu/navigation-sub-menu.scss"],"names":[],"mappings":"AAEA,sBACI,YAAA,CACA,qBAAA,CACA,OAAA,CAGJ,sBACI,YAAA,CACA,qBAAA,CACA,OAAA","sourcesContent":["@import \"~styles/size\";\n\n.subNavigationMenu {\n    display: flex;\n    flex-direction: column;\n    gap: 1px;\n}\n\n.subMenuList {\n    display: flex;\n    flex-direction: column;\n    gap: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breakpointXs": `458px`,
	"breakpointSm": `580px`,
	"breakpointMd": `768px`,
	"breakpointLg": `992px`,
	"breakpointXl": `1200px`,
	"breakpointXxl": `1600px`,
	"subNavigationMenu": `IHc9jwmkyD3tt6WoumDg`,
	"subMenuList": `jjpNcsv5KPzmuNYx4VjG`
};
export default ___CSS_LOADER_EXPORT___;
